/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown>, action: NonNullable<unknown> }} Endpoint_Header_TitleInputs */

const en_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.platform} ${i?.action} API`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.platform) }, { type: "text", value: " " }, { type: "text", value: String(i?.action) }, { type: "text", value: " " }, { type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }])
			})
		}
	)
);

const zh_hans1_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.platform} ${i?.action} API`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.platform) }, { type: "text", value: " " }, { type: "text", value: String(i?.action) }, { type: "text", value: " " }, { type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }])
			})
		}
	)
);

const pt_br2_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`API para ${i?.platform}: ${i?.action}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API para" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.platform) }, { type: "text", value: ": " }, { type: "text", value: String(i?.action) }])
			})
		}
	)
);

const es_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`API de ${i?.platform}: ${i?.action}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API de" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.platform) }, { type: "text", value: ": " }, { type: "text", value: String(i?.action) }])
			})
		}
	)
);

const fr_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.platform} ${i?.action} API`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.platform) }, { type: "text", value: " " }, { type: "text", value: String(i?.action) }, { type: "text", value: " " }, { type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }])
			})
		}
	)
);

const de_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.platform}-${i?.action}-API`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.platform) }, { type: "text", value: "-" }, { type: "text", value: String(i?.action) }, { type: "text", value: "-" }, { type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }])
			})
		}
	)
);

const ru_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.platform} ${i?.action} API`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.platform) }, { type: "text", value: " " }, { type: "text", value: String(i?.action) }, { type: "text", value: " " }, { type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }])
			})
		}
	)
);

const it_endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.platform} ${i?.action} API`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.platform) }, { type: "text", value: " " }, { type: "text", value: String(i?.action) }, { type: "text", value: " " }, { type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "{platform} {action} API" |
*
* @param {Endpoint_Header_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_header_title = /** @type {((inputs: Endpoint_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Endpoint_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Header_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { muted: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_header_title(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_header_title(inputs)
			if (locale === "es") return es_endpoint_header_title(inputs)
			if (locale === "fr") return fr_endpoint_header_title(inputs)
			if (locale === "de") return de_endpoint_header_title(inputs)
			if (locale === "ru") return ru_endpoint_header_title(inputs)
			if (locale === "it") return it_endpoint_header_title(inputs)
			return en_endpoint_header_title(inputs)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_header_title.parts === "function" ? zh_hans1_endpoint_header_title.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_header_title(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_header_title.parts === "function" ? pt_br2_endpoint_header_title.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_header_title(inputs) }]
				if (locale === "es") return typeof es_endpoint_header_title.parts === "function" ? es_endpoint_header_title.parts(inputs) : [{ type: "text", value: es_endpoint_header_title(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_header_title.parts === "function" ? fr_endpoint_header_title.parts(inputs) : [{ type: "text", value: fr_endpoint_header_title(inputs) }]
				if (locale === "de") return typeof de_endpoint_header_title.parts === "function" ? de_endpoint_header_title.parts(inputs) : [{ type: "text", value: de_endpoint_header_title(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_header_title.parts === "function" ? ru_endpoint_header_title.parts(inputs) : [{ type: "text", value: ru_endpoint_header_title(inputs) }]
				if (locale === "it") return typeof it_endpoint_header_title.parts === "function" ? it_endpoint_header_title.parts(inputs) : [{ type: "text", value: it_endpoint_header_title(inputs) }]
				return typeof en_endpoint_header_title.parts === "function" ? en_endpoint_header_title.parts(inputs) : [{ type: "text", value: en_endpoint_header_title(inputs) }]
			})
		}
	)
);